function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0794 14.1249C24.0782 14.4045 24.0219 14.6811 23.9138 14.939C23.8057 15.1968 23.6479 15.4309 23.4493 15.6277C23.2508 15.8246 23.0154 15.9804 22.7566 16.0863C22.4979 16.1922 22.2208 16.2461 21.9412 16.2449H6.05884C5.49616 16.2449 4.95653 16.0213 4.55865 15.6235C4.16078 15.2256 3.93726 14.686 3.93726 14.1233C3.93726 13.5606 4.16078 13.021 4.55865 12.6231C4.95653 12.2252 5.49616 12.0017 6.05884 12.0017H9.03979C8.60144 12.0029 8.17333 11.8692 7.81351 11.6188C7.4537 11.3684 7.17958 11.0134 7.02832 10.602C6.94416 10.3712 6.90125 10.1274 6.90156 9.88174C6.90269 9.60209 6.95889 9.32541 7.06697 9.06749C7.17504 8.80957 7.33286 8.57547 7.53142 8.37856C7.72998 8.18164 7.96539 8.02577 8.2242 7.91985C8.48301 7.81393 8.76015 7.76003 9.03979 7.76123H9.64243C9.25732 5.60796 9.68218 4.72979 10.1715 4.33394C11.1882 3.51216 12.6991 4.60249 14.3862 3.94829C15.809 3.39722 16.5749 1.90728 17.0089 0.649902C18.6879 1.84336 19.4764 3.77319 19.0123 5.45327C18.8467 6.03476 18.5453 6.56861 18.1331 7.01089C17.87 7.29779 17.5719 7.55043 17.2458 7.76284H18.9602C19.2415 7.75836 19.5208 7.8099 19.782 7.91444C20.0432 8.01898 20.2809 8.17444 20.4814 8.37177C20.6819 8.5691 20.8411 8.80434 20.9498 9.06381C21.0585 9.32327 21.1145 9.60177 21.1145 9.88308C21.1145 10.1644 21.0585 10.4429 20.9498 10.7024C20.8411 10.9618 20.6819 11.1971 20.4814 11.3944C20.2809 11.5917 20.0432 11.7472 19.782 11.8517C19.5208 11.9563 19.2415 12.0078 18.9602 12.0033H21.9412C22.2209 12.0022 22.4981 12.0562 22.7569 12.1622C23.0158 12.2682 23.2512 12.4242 23.4498 12.6212C23.6483 12.8182 23.8061 13.0524 23.9142 13.3104C24.0222 13.5684 24.0783 13.8452 24.0794 14.1249Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.401 6.26187C17.0352 7.58477 16.0109 8.32436 15.6344 8.57144H17.3489C17.6285 8.57023 17.9056 8.62413 18.1644 8.73006C18.4233 8.83598 18.6587 8.99185 18.8572 9.18876C19.0558 9.38568 19.2136 9.61978 19.3217 9.8777C19.4298 10.1356 19.486 10.4123 19.4871 10.6919C19.4873 11.169 19.3252 11.632 19.0273 12.0046C19.5834 11.9869 20.1103 11.7513 20.4942 11.3486C20.8781 10.946 21.0884 10.4085 21.0795 9.85217C21.0707 9.29586 20.8436 8.76531 20.4471 8.37499C20.0506 7.98467 19.5166 7.76586 18.9602 7.76577H17.2457C17.6217 7.52031 18.6465 6.78071 19.0123 5.4562C19.4763 3.77612 18.69 1.84629 17.0089 0.652832C16.8235 1.20672 16.5797 1.73931 16.2816 2.2416C17.3376 3.4023 17.7737 4.91265 17.401 6.26187Z",
    fill: "#F0E4FF",
    style: {
      fill: "#F0E4FF",
      fill: "color(display-p3 0.9412 0.8941 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.9412 12.0044H19.0257C18.8249 12.2562 18.5698 12.4594 18.2794 12.5989C17.9891 12.7384 17.671 12.8106 17.3489 12.8101H20.3298C20.8946 12.8078 21.4371 13.0299 21.838 13.4275C22.239 13.8252 22.4656 14.3658 22.4681 14.9306C22.4683 15.4076 22.3062 15.8706 22.0083 16.2433C22.5644 16.2256 23.0912 15.9899 23.4752 15.5873C23.8591 15.1846 24.0693 14.6471 24.0605 14.0908C24.0517 13.5345 23.8246 13.0039 23.4281 12.6136C23.0316 12.2233 22.4975 12.0045 21.9412 12.0044Z",
    fill: "#F0E4FF",
    style: {
      fill: "#F0E4FF",
      fill: "color(display-p3 0.9412 0.8941 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.7508 27.3472H8.24914C7.83999 27.3479 7.44059 27.2223 7.10548 26.9875C6.77038 26.7528 6.51589 26.4203 6.37678 26.0356L3.18528 17.1222C3.1501 17.0227 3.13941 16.9161 3.15411 16.8115C3.16881 16.7069 3.20847 16.6074 3.26973 16.5214C3.33099 16.4354 3.41206 16.3654 3.50609 16.3173C3.60011 16.2692 3.70433 16.2444 3.80993 16.2451H24.19C24.2956 16.2444 24.3998 16.2692 24.4939 16.3173C24.5879 16.3654 24.669 16.4354 24.7302 16.5214C24.7915 16.6074 24.8311 16.7069 24.8458 16.8115C24.8605 16.9161 24.8498 17.0227 24.8147 17.1222L21.6232 26.0382C21.4836 26.4225 21.2289 26.7544 20.8939 26.9886C20.5588 27.2229 20.1596 27.3481 19.7508 27.3472Z",
    fill: "#A38FD1",
    style: {
      fill: "#A38FD1",
      fill: "color(display-p3 0.6392 0.5608 0.8196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.1901 16.2451H23.2233C23.2174 16.2688 23.2109 16.2929 23.2029 16.3166C22.7442 17.558 22.2859 18.7993 21.8279 20.0403C21.1273 21.9379 19.8633 23.576 18.2053 24.7348C16.5474 25.8936 14.5748 26.5179 12.552 26.5238L6.6438 26.5415C6.82926 26.7917 7.07083 26.995 7.34908 27.1349C7.62734 27.2748 7.93454 27.3475 8.246 27.3472H19.7509C20.16 27.3479 20.5594 27.2223 20.8945 26.9875C21.2296 26.7528 21.4841 26.4203 21.6232 26.0356L24.8147 17.1222C24.8499 17.0227 24.8606 16.9161 24.8459 16.8115C24.8312 16.7069 24.7916 16.6074 24.7303 16.5214C24.669 16.4354 24.588 16.3654 24.4939 16.3173C24.3999 16.2692 24.2957 16.2444 24.1901 16.2451Z",
    fill: "#917AC6",
    style: {
      fill: "#917AC6",
      fill: "color(display-p3 0.5686 0.4784 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.1147 16.2811L12.1051 27.3456H12.9108V27.3096L11.9204 16.2451H11.1147C11.1136 16.2559 11.1136 16.2693 11.1147 16.2811Z",
    fill: "#917AC6",
    style: {
      fill: "#917AC6",
      fill: "color(display-p3 0.5686 0.4784 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.8398 26.5186C12.7442 26.5218 12.6486 26.5239 12.5525 26.5239H12.0315L12.1051 27.3457H12.9107V27.3097L12.8398 26.5186Z",
    fill: "#7E63BC",
    style: {
      fill: "#7E63BC",
      fill: "color(display-p3 0.4941 0.3882 0.7373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.0797 16.2451L15.0892 27.3096V27.3456H15.8949L16.8853 16.2811V16.2451H16.0797Z",
    fill: "#917AC6",
    style: {
      fill: "#917AC6",
      fill: "color(display-p3 0.5686 0.4784 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.1924 26.1586L15.0892 27.3113V27.3473H15.8949L16.0254 25.8853C15.7533 25.9884 15.4756 26.0795 15.1924 26.1586Z",
    fill: "#7E63BC",
    style: {
      fill: "#7E63BC",
      fill: "color(display-p3 0.4941 0.3882 0.7373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.8877 27.3472L21.8418 16.3499C21.8507 16.3157 21.8553 16.2805 21.8552 16.2451H21.0361L18.082 27.2424C18.0732 27.2766 18.0686 27.3118 18.0686 27.3472H18.8877Z",
    fill: "#917AC6",
    style: {
      fill: "#917AC6",
      fill: "color(display-p3 0.5686 0.4784 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.8979 24.2053L18.082 27.2426C18.0732 27.2768 18.0686 27.312 18.0686 27.3474H18.8877L20.0317 23.0859C19.6844 23.4889 19.3053 23.8632 18.8979 24.2053Z",
    fill: "#7E63BC",
    style: {
      fill: "#7E63BC",
      fill: "color(display-p3 0.4941 0.3882 0.7373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M6.15816 16.3499L9.11226 27.3472H9.93189C9.93186 27.3118 9.92735 27.2766 9.91846 27.2424L6.96383 16.2451H6.14527C6.14506 16.2804 6.14939 16.3156 6.15816 16.3499Z",
    fill: "#917AC6",
    style: {
      fill: "#917AC6",
      fill: "color(display-p3 0.5686 0.4784 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.72727 26.5322L8.89368 26.5349L9.11228 27.347H9.93191C9.93187 27.3117 9.92736 27.2765 9.91848 27.2423L9.72727 26.5322Z",
    fill: "#7E63BC",
    style: {
      fill: "#7E63BC",
      fill: "color(display-p3 0.4941 0.3882 0.7373)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweet);
export default __webpack_public_path__ + "static/media/sweet.4c5fdcf1dcc4dfc430b03e323169d173.svg";
export { ForwardRef as ReactComponent };